import { createContext, useContext } from 'react'

export type OptionChainOrderClickHandler = (
    type: 'buy' | 'sell' | undefined,
    strike: number,
    callput: 'call' | 'put' | 'otm' | 'itm'
) => void | Promise<void>

export const OptionChainOrderClickContext = createContext<OptionChainOrderClickHandler | null>(null)

export const useOptionChainOrderClick = (): OptionChainOrderClickHandler => {
    const handler = useContext(OptionChainOrderClickContext)
    if (!handler) {
        throw new Error('useOptionChainOrderClick must be used within OptionChainOrderClickContext.Provider')
    }
    return handler
}
